import React, { useState } from 'react';
import { Container, Typography, Box, Paper, Grid, Button } from '@mui/material';
import ViewModeToggle from '../Components/shared/ViewModeToggle';
import BreadcrumbNav from '../Components/shared/BreadcrumbNav';
import FileItem from '../Components/shared/FileItem';
import UploadDialog from '../Components/shared/UploadDialog';
import ConfirmDialog from '../Components/shared/ConfirmDialog';
import MoveDialog from '../Components/shared/MoveDialog';
import ShareDialog from '../Components/shared/ShareDialog';

const TestPage = () => {
  const [viewMode, setViewMode] = useState('grid');
  const [gridSize, setGridSize] = useState(3);
  const [currentPath, setCurrentPath] = useState('');
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [moveDialogOpen, setMoveDialogOpen] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  const handleGridSizeChange = (size) => {
    setGridSize(size);
  };

  const handlePathChange = (path) => {
    setCurrentPath(path);
  };

  const handleUpload = (files) => {
    setUploadDialogOpen(false);
  };

  const handleConfirm = () => {
    setConfirmDialogOpen(false);
  };

  const handleMove = (destination) => {
    setMoveDialogOpen(false);
  };

  const handleShare = (users) => {
    setShareDialogOpen(false);
  };

  const sampleItems = [
    {
      id: '1',
      name: 'Sample Document.pdf',
      type: 'file',
      size: '1.2 MB',
      modified: new Date().toISOString(),
      path: '/sample/path',
      shared: false,
    },
    {
      id: '2',
      name: 'Sample Folder',
      type: 'folder',
      path: '/sample/folder',
      shared: true,
    },
  ];

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Component Test Page
        </Typography>

        <Grid container spacing={4}>
          {/* ViewModeToggle Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                ViewModeToggle
              </Typography>
              <ViewModeToggle
                viewMode={viewMode}
                onViewModeChange={handleViewModeChange}
                gridSize={gridSize}
                onGridSizeChange={handleGridSizeChange}
              />
            </Paper>
          </Grid>

          {/* BreadcrumbNav Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                BreadcrumbNav
              </Typography>
              <BreadcrumbNav
                currentPath={currentPath}
                onPathChange={handlePathChange}
                rootLabel="Test"
              />
            </Paper>
          </Grid>

          {/* FileItem Test */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                FileItem
              </Typography>
              <Grid container spacing={2}>
                {sampleItems.map((item) => (
                  <Grid item xs={12} sm={6} md={4} key={item.id}>
                    <FileItem
                      item={item}
                      viewMode={viewMode}
                      onSelect={() => setSelectedItem(item)}
                      onMenuClick={() => {}}
                    />
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Grid>

          {/* Dialog Tests */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Dialogs
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => setUploadDialogOpen(true)}
                >
                  Test Upload Dialog
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setConfirmDialogOpen(true)}
                >
                  Test Confirm Dialog
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setMoveDialogOpen(true)}
                >
                  Test Move Dialog
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setShareDialogOpen(true)}
                >
                  Test Share Dialog
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* Dialogs */}
        <UploadDialog
          open={uploadDialogOpen}
          onClose={() => setUploadDialogOpen(false)}
          onUpload={handleUpload}
          accept="image/*,.pdf,.doc,.docx"
          multiple
        />

        <ConfirmDialog
          open={confirmDialogOpen}
          onClose={() => setConfirmDialogOpen(false)}
          onConfirm={handleConfirm}
          title="Test Confirmation"
          message="Are you sure you want to perform this action?"
        />

        <MoveDialog
          open={moveDialogOpen}
          onClose={() => setMoveDialogOpen(false)}
          onMove={handleMove}
          currentPath={currentPath}
          item={selectedItem}
        />

        <ShareDialog
          open={shareDialogOpen}
          onClose={() => setShareDialogOpen(false)}
          onShare={handleShare}
          item={selectedItem}
        />
      </Box>
    </Container>
  );
};

export default TestPage; 